import "./Capabilities.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MaterialInventory from "./sections/MaterialInventory";
import TheProductionWorkflow from "./sections/TheProductionWorkflow";
import RequestTechnicalQuote from "./sections/RequestTechnicalQuote";
import SiteFooter from "@/reusable_sections/Footer";
export default function CapabilitiesPage() {
  return <div>
      <MainNavigation />
      <MaterialInventory />
      <TheProductionWorkflow />
      <RequestTechnicalQuote />
      <SiteFooter />
    </div>;
}